module.exports = __webpack_public_path__ + "img/4-original-application.b360fff9.webp";